import axios from 'axios'
import Cookies from 'js-cookie'

const state = {
  currentMatch: null
}

const mutations = {
  SET_CURRENT_MATCH(state, match) {
    state.currentMatch = match
  }
}

const actions = {
  async addFighterToMatch(_, { matchId, fighterId, position }) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/matches/${matchId}/fighter/${fighterId}/position/${position}`,
        {},
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      )
      return response.data
    } catch (error) {
      console.error('Failed to add fighter to match:', error)
      throw error
    }
  },

  async startBattle(_, { matchId }) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/matches/${matchId}/start`,
        {},
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      )
      return response.data
    } catch (error) {
      console.error('Failed to start battle:', error)
      throw error
    }
  },

  async getMatchDetails({ commit }, matchId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/api/matches/${matchId}/details`,
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      )
      commit('SET_CURRENT_MATCH', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Failed to get match details:', error)
      throw error
    }
  },

  async getBattle(_, matchId) {
    try {
      console.log('Fetching battle for match:', matchId);
      
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/api/matches/${matchId}/battle`,
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );

      console.log('Battle API response:', response.data);

      if (!response.data?.data?.battle) {
        throw new Error('Invalid battle data received');
      }

      return response.data.data;
    } catch (error) {
      console.error('Failed to get battle:', error);
      throw error;
    }
  },

  async setMatchVictory(_, { matchId, victory }) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/matches/${matchId}/victory`,
        { winner: victory }, // Enviando o valor numérico (1 ou 2) como winner
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      )
      return response.data
    } catch (error) {
      console.error('Failed to set match victory:', error)
      throw error
    }
  }
}

const getters = {
  getCurrentMatch: state => state.currentMatch
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
